$(function (){
  $(".remove_additional_product").bind("click", function (e){
    var btn = $(e.target);
    var form = btn.parents("form");
    if(btn.not("a")){
      btn = $(btn.closest("a").get(0));
    }
    var id = btn.data("products-id");
    var row = $("#additional_skus_table #additional_product_"+id);
    row.remove();
    form.submit();
    return false;
  });

});



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/products.js